import type { PermissionsRouteProps } from "@/components/types"
import { useCurrentUser, useCustomer } from "@/hooks/reduxHooks"
import { CenteredLoadingWavelengthRadio } from "@/icons/LoadingWavelengthRadio"
import { memo, Suspense, useMemo } from "react"
import { Navigate, useLocation } from "react-router-dom"

const PermissionsRoute = ({
  allowedIf,
  component: Component,
  // children,
}: PermissionsRouteProps) => {
  const location = useLocation()
  const customer = useCustomer()
  const currentUser = useCurrentUser()

  const redirectLocation = useMemo(
    () => ({ pathname: "/login", state: { from: location } }),
    [location],
  )

  const isNotAllowed = useMemo(
    () => !allowedIf(customer, currentUser),
    [allowedIf, customer, currentUser],
  )

  if (isNotAllowed) {
    return <Navigate to={redirectLocation.pathname} state={redirectLocation.state} replace />
  }

  return (
    <Suspense fallback={<CenteredLoadingWavelengthRadio />}>
      <Component />
    </Suspense>
  )
}

export default memo(PermissionsRoute)
